export enum DuelWebsocketClientActions {
  GET_PLAYER_STATE = 'GET_PLAYER_STATE',
  JOIN_QUEUE = 'JOIN_QUEUE',
  LEAVE_QUEUE = 'LEAVE_QUEUE',
  BAN_MAP = 'BAN_MAP',
  MATCH_RESULT_ACCEPTED = 'MATCH_RESULT_ACCEPTED',
}
